// Birim engel tablosu / katalog bandı derin bağlantıları (TODO-KPI-96): hedef ekran gösterge
// bağlamını `?metricId=` ile alır. Okuma tarafı saf yardımcılar — sayfalar yalnız bunları çağırır.

export type KpiMetricLinkTarget = "/clients/kpi/tablo" | "/clients/kpi/hedefler";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** `/clients/kpi/tablo?metricId=<id>` — gösterge bilinmiyorsa süzgeçsiz yol. */
export function kpiMetricLink(target: KpiMetricLinkTarget, metricId: string | null): string {
  return metricId && UUID.test(metricId) ? `${target}?metricId=${metricId}` : target;
}

/** Veri Yönetimi "Kırılıma dönüştür" kısayolu → katalogda sihirbaz (TODO-KPI-116). */
export function kpiConvertLegacyHref(metricId: string): string {
  return `/clients/kpi/katalog?convert=${metricId}`;
}

/** `?metricId=` değerini okur; geçersiz/yok → null. */
export function readMetricIdParam(search: string): string | null {
  const v = new URLSearchParams(search).get("metricId");
  return v && UUID.test(v) ? v : null;
}

/** Veri Girişi: `metricId` → ızgaradaki göstergenin kodu (highlight akışına bağlanır). */
export function codeForMetricId(
  indicators: readonly { metricId: string; code: string }[],
  metricId: string | null,
): string | null {
  if (!metricId) return null;
  return indicators.find((i) => i.metricId === metricId)?.code ?? null;
}
